import React from 'react';
import { Button } from './ui/button';
import { Globe } from 'lucide-react';

export const LanguageSwitcher = ({ currentLang, onLanguageChange }) => {
  return (
    <div className="flex items-center gap-2 backdrop-blur-xl bg-white/5 border border-white/10 rounded-xl px-4 py-2 hover:border-[#C5A05E]/50 transition-all duration-300">
      <Globe className="w-4 h-4 text-[#C5A05E]" />
      <Button
        variant="ghost"
        size="sm"
        onClick={() => onLanguageChange(currentLang === 'sq' ? 'en' : 'sq')}
        className="font-semibold text-white hover:text-[#C5A05E] hover:bg-transparent transition-colors p-0"
        data-testid={currentLang === 'sq' ? 'lang-en' : 'lang-sq'}
      >
        {currentLang === 'sq' ? 'EN' : 'SQ'}
      </Button>
    </div>
  );
};